import Routers from './Router';

function App() {
  return (
    <>
      <Routers />
    </>
  );
}

export default App;
